import isNil from 'lodash/isNil';
export default function isEmpty(value, allowBlank = false) {
    return isNil(value) || (allowBlank ? false : value === '');
}
